var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.331,
    height: 10.346,
    viewBox: "0 0 14.331 10.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verified",
    transform: "translate(-96.904 -335.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "done_FILL0_wght400_GRAD0_opsz48",
    d: "M12.631,22.546,7.7,17.615l.947-.947,3.984,3.984L21.084,12.2l.947.947Z",
    transform: "translate(89.204 323.743)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2ed41f6dc9b4973f05654f3bca5503b2.svg";
export { ForwardRef as ReactComponent };